import { render } from "./IndividualPurchaseField.vue?vue&type=template&id=6060fd48&ts=true"
import script from "./IndividualPurchaseField.vue?vue&type=script&lang=ts"
export * from "./IndividualPurchaseField.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__